import { CircularLoader as CXCircularLoader } from '@sanlamcx/react-ui-next-circular-loader';

type CircularLoader = typeof CXCircularLoader;
export const CircularLoader: CircularLoader = CXCircularLoader;
